var _defs, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDesplegar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200.4 125.06",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Desplegar_svg__cls-1{fill:#5d5a5a}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Desplegar_svg__cls-1",
    d: "M3.51 47.66l95.94 76a6 6 0 007.86-.17l89.76-76c3.39-2.87 4.34-8.76 2.12-13.15s-6.78-5.62-10.18-2.74l-85.86 72.7-91.96-72.81c-3.46-2.74-8-1.33-10.11 3.14s-1 10.32 2.43 13.06z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Desplegar_svg__cls-1",
    d: "M32.94 17.98l66.51 52.68a6 6 0 007.86-.17l62.68-53c3.4-2.88 4.34-8.77 2.12-13.16s-6.78-5.61-10.18-2.74l-58.77 49.73L40.62 1.78c-3.46-2.75-8-1.34-10.11 3.13s-1 10.32 2.43 13.07z"
  })));
}

export default SvgDesplegar;